import { Actions } from './actions';
import { Links } from './links';
import css from './docs.module.scss';

export function Docs() {
    return (
        <div className={css.wrapper}>
            <Actions />
            <Links />
        </div>
    );
}
